import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "general/label"

class service {

    mount(labelId, foreignKey) {

        let params = new URLSearchParams()
        params.set("labelId", labelId)
        params.set("foreignKey", foreignKey)

        return http.list(path + "/selectRelationList",params)
    }

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

    print(form) {

        return http.post(path + "/print",form)
    }

}

export default new service();


